import ImgExampleIcon from '../assets/learn/example-icon.png';

export function processCourseIconUrl(iconUrl) {
  if (iconUrl.startsWith('http://') || iconUrl.startsWith('https://')) {
    return iconUrl
  }
  return ImgExampleIcon
}